import { createContext, useContext, useState, ReactNode } from 'react';
import { Message } from './useScoutChat';

interface ScoutChatContextValue {
  messages: Message[];
  setMessages: (messages: Message[]) => void;
  hasActiveChat: boolean;
  setHasActiveChat: (has: boolean) => void;
}

const ScoutChatContext = createContext<ScoutChatContextValue | undefined>(
  undefined,
);

export const ScoutChatProvider = ({ children }: { children: ReactNode }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [hasActiveChat, setHasActiveChat] = useState(false);

  return (
    <ScoutChatContext.Provider
      value={{
        messages,
        setMessages,
        hasActiveChat,
        setHasActiveChat,
      }}
    >
      {children}
    </ScoutChatContext.Provider>
  );
};

export const useScoutChatContext = () => {
  const context = useContext(ScoutChatContext);
  if (!context) {
    throw new Error(
      'useScoutChatContext must be used within ScoutChatProvider',
    );
  }
  return context;
};
